import { TrackingEnv } from 'src/app/core/services/tracking/tracking.env';

export enum AppType {
  RC = 'royal-canin',
  WL = 'wl-default',
  MVR = 'wl-my-vet-reco',
}

export enum AppTitle {
  ROYAL_CANIN = 'Royal Canin',
  WHITE_LABEL_DEFAULT = 'White Label',
  MY_VET_RECO = 'MyVetReco',
}

export interface IEnvironment {
  production: boolean;
  ciamAPIUrl: string;
  apimAPIUrl: string;
  contactUsApiUrl: string;
  myAccountBffUrl: string;
  OcpApimSubscriptionKey: string;
  globalRedirectUri: string;
  environmentName: 'dev' | 'uat' | 'stg' | 'prd';
  trackingEnv: TrackingEnv;
  okta: {
    domain: string;
    clientId: string;
    socialIdp: {
      facebook: string;
      google: string;
      paypal: string;
      apple: string;
      kakao: string;
    };
  };
  appType: AppType;
  isWhiteLabel: boolean;
  whiteLabelConfiguration?: {
    footer?: string;
  };
  gdpRedirectURI: string;
}
